import WidgetHome from "@/components/WidgetHome";
import React from "react";
import styles from "./HeroSection.module.css";
import SeoCtaLink from "@components/SeoCtaLink";
import { FREE_APPLICATION_CREDITS_DESCRIPTION } from "@src/config/freeTrial";

const HeroSection = () => {
  return (
    <section
      id="hero"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        textAlign: "left",
        boxSizing: "border-box",
        width: "100%",
        maxWidth: "1100px",
        margin: "0 auto",
      }}
      className={styles.heroSection}
    >
      {/* Text Section */}
      <div
        style={{
          flex: "1",
        }}
        className={styles.heroText}
      >
        <h1
          style={{
            fontSize: "36px",
            fontWeight: 500,
            lineHeight: "1.1",
            color: "rgb(2, 9, 21)",
            marginBottom: "20px",
          }}
        >
          Spend less time applying. <span style={{ color: "rgb(104, 91, 255)", fontWeight: "700" }}>Focus on your search.</span>
        </h1>

        <p
          style={{
            fontSize: "20px",
            fontWeight: 500,
            lineHeight: "1.4",
            letterSpacing: "-0.02em",
            color: "rgb(2, 9, 21)",
            marginBottom: "30px",
          }}
        >
          LifeShack is an AI auto-apply agent: set your preferences, prepare tailored materials, and automate supported job applications.
        </p>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: "15px",
            width: "100%",
          }}
          className={styles.heroButtons}
        >
          <SeoCtaLink
            href="/signup/?utm_source=website&utm_medium=organic&utm_campaign=homepage&utm_content=hero"
            pageType="home"
            placement="hero"
            className={styles.heroButton}
          >
            Start with free application credits
          </SeoCtaLink>

          <p
            style={{
              fontSize: "18px",
              color: "rgb(2, 9, 21)",
            }}
          >
            {FREE_APPLICATION_CREDITS_DESCRIPTION}
          </p>
        </div>
      </div>

      {/* Video Section */}
      <div
        className={styles.heroVideo}
      >
        <WidgetHome />
        </div>
    </section>
  );
};

export default HeroSection;
